<app-header [title]="title"></app-header>
<div class="redirect-pge">
  <div class="redirect-midd">
    <h4>Multiple page not allowed</h4>
    <span>There is one previous instance of iAR application already running on the browser. <br> Please close this instance and go to other running instance of iAR application. </span>
  </div>
</div>
